import React, { useRef, useEffect, useState } from "react"
import styles from "@/styles/footerNav.module.scss"
import Sizing from "./Sizing"
import Cursor from "./Cursor"
import pattern from "@/images/footer-copy-fill.png"
import { af as AF } from "@gladeye/af"
import { Link } from "gatsby"

import climateA from "@/images/footer/active/climate.png"
import climateI from "@/images/footer/idle/climate.png"

import rentsA from "@/images/footer/active/rents.png"
import rentsI from "@/images/footer/idle/rents.png"

import boredomA from "@/images/footer/active/boredom.png"
import boredomI from "@/images/footer/idle/boredom.png"

import hungerA from "@/images/footer/active/hunger.png"
import hungerI from "@/images/footer/idle/hunger.png"

import diseaseA from "@/images/footer/active/disease.png"
import diseaseI from "@/images/footer/idle/disease.png"

import racismA from "@/images/footer/active/racism.png"
import racismI from "@/images/footer/idle/racism.png"

import climateA_Spanish from "@/images/footer/active/climate_spanish.png"
import climateI_Spanish from "@/images/footer/idle/climate_spanish.png"

import rentsA_Spanish from "@/images/footer/active/rents_spanish.png"
import rentsI_Spanish from "@/images/footer/idle/rents_spanish.png"

import boredomA_Spanish from "@/images/footer/active/boredom_spanish.png"
import boredomI_Spanish from "@/images/footer/idle/boredom_spanish.png"

import hungerA_Spanish from "@/images/footer/active/hunger_spanish.png"
import hungerI_Spanish from "@/images/footer/idle/hunger_spanish.png"

import diseaseA_Spanish from "@/images/footer/active/disease_spanish.png"
import diseaseI_Spanish from "@/images/footer/idle/disease_spanish.png"

import racismA_Spanish from "@/images/footer/active/racism_spanish.png"
import racismI_Spanish from "@/images/footer/idle/racism_spanish.png"

const colors = {
    red: "#EC5843",
    pink: "#F2AEBB",
    lilac: "#B783B9",
    orange: "#E99245",
    teal: "#68C5B8",
    green: "#D1DD26",
    blue: "#3699DD",
}

const sections = {
    climate: {
        link: "climate-change",
        // text: "CLIMATE CHANGE",
        images: {
            en: [climateI, climateA],
            es: [climateI_Spanish, climateA_Spanish],
        },
        g1: [colors.green, colors.teal],
        g2: [colors.orange, colors.blue],
    },
    disease: {
        link: "disease",
        // text: "DISEASE",
        images: {
            en: [diseaseI, diseaseA],
            es: [diseaseI_Spanish, diseaseA_Spanish],
        },
        g1: [colors.pink, colors.orange],
        g2: [colors.green, colors.teal],
    },
    rents: {
        link: "high-rents",
        // text: "HIGH RENTS",
        images: {
            en: [rentsI, rentsA],
            es: [rentsI_Spanish, rentsA_Spanish],
        },
        g1: [colors.pink, colors.lilac],
        g2: [colors.red, colors.teal],
    },
    boredom: {
        link: "boredom",
        // text: "BOREDOM",
        images: {
            en: [boredomI, boredomA],
            es: [boredomI_Spanish, boredomA_Spanish],
        },
        g1: [colors.lilac, colors.blue],
        g2: [colors.red, colors.green],
    },
    hunger: {
        link: "hunger",
        // text: "HUNGER",
        images: {
            en: [hungerI, hungerA],
            es: [hungerI_Spanish, hungerA_Spanish],
        },
        g1: [colors.teal, colors.lilac],
        g2: [colors.orange, colors.pink],
    },
    racism: {
        link: "racism",
        // text: "HUNGER",
        images: {
            en: [racismI, racismA],
            es: [racismI_Spanish, racismA_Spanish],
        },
        g1: [colors.teal, colors.orange],
        g2: [colors.pink, colors.green],
    },
}

const generateFooterItem = (section, active, langKey) => {
    const { images } = sections[section]

    // console.log(img)
    const g1 = `linear-gradient(90deg, ${sections[section].g1[0]} 0%, ${sections[section].g1[1]} 60%)`
    const g2 = `linear-gradient(90deg, ${sections[section].g2[0]} 0%, ${sections[section].g2[1]} 60%)`

    function getClass(className) {
        return styles[className] + " " + styles[`${className}_${section}`]
    }

    let id = 0

    return (
        <>
            <div
                className={getClass("bg") + ` ${active ? "" : styles.inactive}`}
                style={{ "--g1": g1 }}
            ></div>
            <div
                className={styles.grain + ` ${active ? "" : styles.inactive}`}
            ></div>
            <div
                className={
                    getClass("texture") + ` ${active ? "" : styles.inactive}`
                }
                style={{ "--g2": g2 }}
            ></div>
            <div
                className={
                    getClass("motif") + ` ${active ? "" : styles.inactive}`
                }
            ></div>

            <Sizing
                styles={{ position: "relative", zIndex: 5, height: "100%" }}
                breaks={[
                    {
                        min: 0,
                        val: {
                            paddingLeft: 0,
                        },
                    },
                    {
                        min: 1024,
                        val: {
                            paddingLeft: 2,
                        },
                    },
                ]}
            >
                <div className={styles.content}>
                    <span
                        className={
                            `copy--lead ${active ? "copy--white" : ""} ` +
                            styles.copy
                        }
                    >
                        Free Markets Destroy
                    </span>

                    <div className={styles.titleContainer}>
                        <img src={images[langKey][0]} alt="" />
                        <img
                            src={images[langKey][1]}
                            className={active ? styles.active : ""}
                            alt=""
                        />
                    </div>

                    <span
                        className={
                            styles.arrow + " " + (active ? styles.active : "")
                        }
                    >
                        <svg
                            viewBox="0 0 72 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M51.1364 41L71.5 20.6364L51.1364 0.272728L47.6364 3.72727L62.0455 18.1364H0V23.1364H62.0455L47.6364 37.5L51.1364 41Z" />
                        </svg>
                    </span>
                </div>
            </Sizing>
        </>
    )
}

const FooterNav = ({ next, previous, langKey }) => {
    const prevEl = useRef()
    const nextEl = useRef()
    const [nextActive, setNextActive] = useState(false)
    const [prevActive, setPrevActive] = useState(false)

    useEffect(() => {
        const af = AF()
        const mouse = { x: 0, y: 0 }
        const nextAnim = { x: 0, y: 0 }
        const prevAnim = { x: 0, y: 0 }

        const motif = {
            next: nextEl.current.querySelector("." + styles.motif),
            prev: prevEl.current.querySelector("." + styles.motif),
        }

        const texture = {
            next: nextEl.current.querySelector("." + styles.texture),
            prev: prevEl.current.querySelector("." + styles.texture),
        }

        const write = () => {
            if (window.innerWidth < 1024) return
            if (nextActive) {
                nextAnim.x += (mouse.x - nextAnim.x) * 0.1
                nextAnim.y += (mouse.y - nextAnim.y) * 0.1
                motif.next.style.transform = `translate3d(${nextAnim.x * -5}%,${
                    nextAnim.y * -5
                }%, 1px)`
                texture.next.style.transform = `translate3d(${
                    nextAnim.x * -2
                }%,${nextAnim.y * -2}%, 1px)`
            }
            if (prevActive) {
                prevAnim.x += (mouse.x - prevAnim.x) * 0.1
                prevAnim.y += (mouse.y - prevAnim.y) * 0.1
                motif.prev.style.transform = `translate3d(${prevAnim.x * -2}%,${
                    prevAnim.y * -5
                }%, 1px)`

                texture.prev.style.transform = `translate3d(${
                    prevAnim.x * -2
                }%,${prevAnim.y * -2}%, 1px)`
            }
        }

        function mousemove(e) {
            const { clientX, clientY } = e

            const x = (clientX / window.innerWidth) * 2 - 1
            const y = (clientY / window.innerHeight) * 2 - 1

            mouse.x = x
            mouse.y = y
        }

        function leave(e) {
            if (this === nextEl.current) setNextActive(false)
            else setPrevActive(false)
        }

        function enter(e) {
            if (this === nextEl.current) setNextActive(true)
            else setPrevActive(true)
        }

        nextEl.current.addEventListener("mouseenter", enter)
        nextEl.current.addEventListener("mouseleave", leave)

        prevEl.current.addEventListener("mouseenter", enter)
        prevEl.current.addEventListener("mouseleave", leave)

        window.addEventListener("mousemove", mousemove)

        af.addWrite(write)

        return () => {
            af.removeWrite(write)

            nextEl.current.removeEventListener("mouseenter", enter)
            nextEl.current.removeEventListener("mouseleave", leave)

            prevEl.current.removeEventListener("mouseenter", enter)
            prevEl.current.removeEventListener("mouseleave", leave)

            window.removeEventListener("mousemove", mousemove)
        }
    }, [nextActive, prevActive])

    return (
        <>
            <div className={styles.main + " hand"}>
                <Link to={`/${langKey}/` + sections[previous].link}>
                    <div ref={prevEl} className={styles.previous}>
                        {generateFooterItem(previous, prevActive, langKey)}
                    </div>
                </Link>

                <Link to={`/${langKey}/` + sections[next].link}>
                    <div ref={nextEl} className={styles.next}>
                        {generateFooterItem(next, nextActive, langKey)}
                    </div>
                </Link>

                <Cursor active={nextActive || prevActive}></Cursor>
            </div>
        </>
    )
}

export default FooterNav
